import { render } from "./OrderItemsTable.html?vue&type=template&id=28707a1c&scoped=true"
import script from "./OrderItemsTable.js?vue&type=script&lang=js"
export * from "./OrderItemsTable.js?vue&type=script&lang=js"

import "./OrderItemsTable.css?vue&type=style&index=0&id=28707a1c&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28707a1c"]])

export default __exports__